module.exports = __webpack_public_path__ + "img/setup-jp-modal.79b9036a.svg";